module.exports = __webpack_public_path__ + "static/media/projects2.a9219df7.jpg";